// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"9163bc82","155":"8e0694c6","299":"51932984","349":"1e19ef66","596":"cc9ec148","966":"4a28b1f0"}[chunkId] + ".chunk.js";
};